/* @flow */

import { type State } from './types';

const getPersistedState = (state: State) => ({
    usuario: state.usuario,
    notificacoes: state.notificacoes,
    balcao: {
        cliente: state.balcao.cliente,
        itens: state.balcao.itens,
        endereco: state.balcao.endereco,
        detalhesProduto: state.balcao.detalhesProduto,
        pedido: state.balcao.pedido,
    },
    empresa: state.empresa,
    funcionamento: state.funcionamento,
});

export default getPersistedState;
